var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBep20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#48CF8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4415 13.0372V13.0358C13.359 13.0418 12.9337 13.0673 11.985 13.0673C11.2275 13.0673 10.6943 13.0448 10.5068 13.0358V13.038C7.59075 12.9098 5.41425 12.402 5.41425 11.7945C5.41425 11.1878 7.59075 10.68 10.5068 10.5495V12.5325C10.6973 12.546 11.2433 12.5782 11.9978 12.5782C12.903 12.5782 13.3568 12.5408 13.4415 12.5333V10.551C16.3515 10.6808 18.5227 11.1885 18.5227 11.7945C18.5227 12.402 16.3515 12.9082 13.4415 13.0372ZM13.4415 10.3448V8.57025H17.502V5.86425H6.44625V8.57025H10.5068V10.344C7.20675 10.4955 4.725 11.1495 4.725 11.9325C4.725 12.7155 7.20675 13.3687 10.5068 13.521V19.2075H13.4415V13.5195C16.7363 13.368 19.212 12.7147 19.212 11.9325C19.212 11.1502 16.7363 10.497 13.4415 10.3448Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 24C26.4183 24 30 20.4183 30 16C30 11.5817 26.4183 8 22 8C17.5817 8 14 11.5817 14 16C14 20.4183 17.5817 24 22 24Z",
    fill: "#F3BA2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.058 15.202L22 13.26L23.943 15.203L25.073 14.073L22 11L18.928 14.072L20.058 15.202ZM17 16L18.13 14.87L19.26 16L18.13 17.13L17 16ZM20.058 16.798L22 18.74L23.943 16.797L25.073 17.9265L22 21L18.928 17.928L18.9265 17.9265L20.058 16.798ZM24.74 16L25.87 14.87L27 16L25.87 17.13L24.74 16ZM23.146 15.999H23.147V16L22 17.147L20.8545 16.002L20.8525 16L20.8545 15.9985L21.055 15.7975L21.1525 15.7L22 14.853L23.1465 15.9995L23.146 15.999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBep20);
export default __webpack_public_path__ + "static/media/bep-20.7aa30b3c3165eab6716ac57aaddd65b3.svg";
export { ForwardRef as ReactComponent };